// "Download" / "Download All" on the Screenshots tab.
//
// Screenshots are S3 URLs now. An S3 image loaded in a hidden iframe just
// renders there instead of downloading, so fetch it and save the blob through a
// temporary <a download>. If the fetch fails (CORS, 403, offline) the image
// opens in a new tab, where the user can still save it.
//
// ponytail: legacy Drive screenshots keep Drive's export=download link in a
// hidden iframe, which Drive answers with a real download. Delete that branch
// once no Drive URLs remain.

// Screenshot URLs come from a table any project viewer can insert into, so
// before this ever reaches window.open or an <a>/<iframe> src, it must be a
// plain web URL — never javascript:, data:, or anything else script-capable.
export function isWebUrl(url) {
  try {
    const { protocol } = new URL(url);
    return protocol === "http:" || protocol === "https:";
  } catch {
    return false;
  }
}

export async function downloadFile(url) {
  if (!url) return;

  if (!isWebUrl(url)) {
    console.warn("[Screenshots] refusing to download non-web URL:", url);
    return;
  }

  if (/drive\.google\.com/i.test(url)) {
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = url.replace("export=view", "export=download");
    document.body.appendChild(iframe);
    setTimeout(() => iframe.remove(), 60000);
    return;
  }

  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const blob = await res.blob();

    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = fileNameFromUrl(url);
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(a.href);
  } catch (err) {
    console.warn("[Screenshots] download failed, opening instead:", err);
    window.open(url, "_blank", "noopener,noreferrer");
  }
}

function fileNameFromUrl(url) {
  try {
    const last = new URL(url).pathname.split("/").pop();
    if (last) return decodeURIComponent(last);
  } catch {}
  return "screenshot.png";
}
